export default __webpack_public_path__ + "assets/8209454a344bd99980ab05c932e0aedf.svg";